import { Dispatch, useCallback } from 'react';
import { AppState, MainContextActionTypes } from '@constants';
import useHandleMfaStateChanged from './useHandleMfaStateChanged';
import useLoadCreditsInfo from './useLoadCreditsInfo';

function useLoadAllUserInfo(state: AppState, dispatch: Dispatch<MainContextActionTypes>) {
  const handleMfaStateChanged = useHandleMfaStateChanged(state.firebaseAuth);
  const loadCreditsInfo = useLoadCreditsInfo(state.firebaseAuth, dispatch);

  const loadAllUserInfo = useCallback(async () => {
    await handleMfaStateChanged();

    if (!state.firebaseLoaded) {
      return;
    }

    await loadCreditsInfo();
  }, [state.firebaseLoaded, handleMfaStateChanged, loadCreditsInfo]);

  return loadAllUserInfo;
}

export default useLoadAllUserInfo;
